import React from 'react'
import { NumberFieldSeeker } from '@ui-seeker/core'
import { number, object } from 'yup'
import { useAppFormHandler } from '@hooks'


export default function SeatsSelector() {
	const validation = object({
		seats: number().nullable()
			.min(0, 'Must provide between 0 and 12')
			.max(12, 'Must provide between 0 and 12'),
	})
	const { seats, onSeatsChange, error } = useAppFormHandler('seats', validation)

	return <NumberFieldSeeker
		value={seats === null ? '' : seats}
		error={error}
		label="Seats"
		onChange={e => onSeatsChange(e.target.value || 0)}
	/>
}